import { ArrowBack, Arrowdown2, Cancel, Forward } from "../../../assets";
import { Button, CustomModal, Dropdown, Input, Layout, FilterInput,EmptyTable, TableRowResponsive } from "../../components";
import { CommissionController } from "../../controllers";
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { Helmet } from "react-helmet-async";
import { Accordion, AccordionDetails, AccordionSummary, LinearProgress, Pagination, PaginationItem } from "@mui/material";
import moment from "moment-jalaali";
function CustomInput({ onFocus, value, onChange }: any) {

  return (
      <>
          <Input customFocus={onFocus} myStyle="w-100" title="تاریخ تولد" value={value} onChange={onChange}  />
      </>
  )
}
class Commission extends CommissionController {
  componentDidMount() {
    this.getList()

    window.scrollTo(0, 0);
  }
  render() {
    const { 
      from_date,
      to_date,
      loading
    } = this.state;
    return (
      <Layout title=" کارمزد ها">
         <Helmet>
        <title>کارمزد ها  | بیمه زندگی هامرز</title>
      </Helmet>
      {loading ?
          <LinearProgress />
          :
          <>
        {/* <FilterInput isCommission totalFeeNumber={0} endDate="1402/07/01" startDate="1402/07/01" duration="1ماهه" buttonTitle="فیلترها" placeholder="فیلتر های بیمه نامه" onClick={() => this.setState({ openModal: !this.state.openModal })} str={this.state.str} /> */}


        <div className="commission table-responsive scrollbar">
          <table className="table hide-mobile">
            <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">شماره بیمه نامه</th>
                <th scope="col">نام و نام خانوادگی بیمه گذار</th>
                <th scope="col"> نام و نام خانوادگی بیمه شده </th>
                <th scope="col"> مبلغ واریزی  </th>
                <th scope="col">کارمزد (ریال)</th>
                <th scope="col"> تاریخ واریز  </th>
              </tr>
            </thead>
            <tbody>
            {this.state.commissionList?.data?.length > 0 && this.state.commissionList?.data?.map((item: any, index: number) => {
                return (

                  <tr>
                <th>{index + 1}</th>
                <td> {item?.instalment_number}</td>
                <td> {`${item?.policy_holder_first_name} ${item?.policy_holder_last_name}`}</td>

                <td> {`${item?.policy_holder_first_name} ${item?.policy_holder_last_name}`}</td>

                <td> {item?.amount}</td>

                <td> {item?.commission}</td>

                <td> {moment(`${item?.effect_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} </td>


              </tr>
                )
              })}

           


            </tbody>
          </table>

          {this.state.commissionList?.data?.length > 0 ? <>
          <Accordion className="policy-accordion hide-desktop">
            <AccordionSummary
              expandIcon={<img alt="هامرز" src={Arrowdown2} />}
              aria-controls="panel1a-content"
              className="summsry"
              id="panel1a-header"
            >
              <TableRowResponsive title="ردیف" value="6" />
              <TableRowResponsive title="نام و نام خانوادگی" value=" حسین والی زاده" />
              <TableRowResponsive title="کد ملی" value="1451513224" />
            </AccordionSummary>
            <AccordionDetails
              className="d-flex flex-wrap"
            >
              <TableRowResponsive title="تاریخ اثر " value="1402/02/21" />
              <TableRowResponsive title="تاریخ سررسید قسط " value="1402/02/21" />
              <TableRowResponsive title="شماره بیمه نامه" value="0212665875412" />


            </AccordionDetails>
            <AccordionDetails
              className="d-flex flex-wrap"
            >
              <TableRowResponsive title=" شماره قسط  " value="سال : 1 / شماره قسط 1" />

              <TableRowResponsive title="نوع کارمزد " value="حق وصول" />
              <TableRowResponsive title="مبلغ قسط (ریال)" value="15.000.000" />
            </AccordionDetails>
            <AccordionDetails
              className="d-flex flex-wrap"
            >
              <TableRowResponsive title="کارمزد (ریال)" value="0" />
            </AccordionDetails>
          </Accordion>
          {/* <Pagination
            className="custom-pagination"
            count={this.state.commissionList?.total_count ? Math.ceil(this.state.commissionList?.total_count / 10) : 1}
            // page={currentPage + 1}
            onChange={this.handleChangePage}
           size="small"
            renderItem={(item) => (
              <PaginationItem
                slots={{ previous: Forward, next: ArrowBack }}
                {...item}
              />
            )}
          /> */}
          </>
:         
 <EmptyTable title="اطلاعاتی برای نمایش وجود ندارد"/>
}
        </div>
        <CustomModal myStyle="commission-modal" openModal={this.state.openModal} onClose={() => this.setState({ openModal: !this.state.openModal })}>


          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
                فیلتر های کارمزد ها
              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                  فیلتر های اعلام شده :
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <h2 className="custom-modal-title">
              بر اساس اطلاعات بیمه گذار
            </h2>



            <div className="custom-modal-row">
            <DatePicker
            ref={this.datePickerRef}
            render={<CustomInput/>}
         dateSeparator=" تا " 
         calendar={persian}
         locale={persian_fa}
         placeholder=" از تاریخ "
         containerClassName="filter-date-container"
         inputClass="custom-date-input"
         calendarPosition="bottom-right"
      />
      <DatePicker
      ref={this.datePickerRef}
      render={<CustomInput/>}
         dateSeparator=" تا " 
         calendar={persian}
         locale={persian_fa}
         placeholder="تا تاریخ"
         containerClassName="filter-date-container"
         inputClass="custom-date-input"
         calendarPosition="bottom-right"
      />
              <Input myStyle="custom-modal-item" title="نام خانوادگی بیمه گذار" value={this.state.value} onChange={this.handleChange} />

            </div>
            <h2 className="custom-modal-title mt-33">
              بر اساس اطلاعات بیمه
            </h2>
            <div className="custom-modal-row ">
              <Dropdown myStyle="custom-modal-item" title="  نوع کارمزد" value={this.state.value} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="شماره بیمه نامه" value={this.state.value} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="کد ملی بیمه گذار" value={this.state.value} onChange={this.handleChange} />
            </div>

            <div className="custom-modal-confirm">
              <Button myStyle="bg-green" title="اعمال" onClick={()=>{}} />
            </div>

          </>
        </CustomModal>
        </>
  }
      </Layout>
    )
  }
}
export default Commission;